import { render, staticRenderFns } from "./ConsultoriasDash.vue?vue&type=template&id=70fe5fa7"
import script from "./ConsultoriasDash.vue?vue&type=script&lang=js"
export * from "./ConsultoriasDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports